<template>
    <v-col cols="12" class="pr-6">        
        <v-row align="center" justify="space-between">
            <v-col
                cols="12"
                class="py-0 px-6"
                v-for="(row, h) in matrix"
                :key="'row-'+h"
            >
                <v-row
                    class="fill-height mb-6"
                    align="center"
                    justify="start"
                >
                    <v-col
                        class="customCols"
                        v-for="(skin, k) in row"
                        :key="'skin-'+k"
                    >
                        <Skin :skin="skin" v-on:favorite="verifyFavorite" v-on:toBuy="toBuy" />
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row
            style="height: 15vh"
            align="center"
            justify="center"
            v-if="!favoriteView && matrix.length>0"
        >
            <v-img
                :src="require('../../assets/img/arrows/flecha-volver.svg')"
                elevation="6"
                contain
                :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                style="align-items: center; margin-right: 1.5vw; cursor: pointer;"
                @click="previous"
            >
                <p class="button-next-2-text-2">{{ $t('store.previous') }}</p>
            </v-img>
            <v-col cols="12" md="2">
                <span class="page-number">
                    {{ (currentPage + 1) }}
                </span>
                <span class="page-total-number">
                    {{ $t('store.of') + totalPages }}
                </span>
            </v-col>
            <v-img
                :src="require('../../assets/img/arrows/flecha-siguiente.svg')"
                elevation="6"
                contain
                :max-width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :width="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'25vw':'7vw'"
                :max-height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                :height="this.$vuetify.breakpoint.xs||this.$vuetify.breakpoint.sm||this.$vuetify.breakpoint.md?'15vw':'4vw'"
                style="align-items: center; cursor: pointer;"
                @click="next"
            >
                <p class="button-next-2-text-1">{{ $t('store.next') }}</p>
            </v-img>
        </v-row>
    </v-col>
</template>

<script>

import { mapState } from 'vuex'
import Skin from './Skin.vue'
import PurchaseService from '../../services/purchase'
import UserSkinService from '../../services/userSkin'
import SkinFavoriteService from '../../services/skinFavorite'

export default {
    props: {
        favoriteView: { type: Boolean, default: false },
        reload: { type: Number, default: 0 },
        search: { type: String, default: '' }
    },
    components: {
        Skin
    },
    data() {
        return {
            currentPage: 0,
            favorites: null,
            paySkins: [],
            purchases: null,
            totalPages: 0
        }
    },
    computed: {
        ...mapState({
            user: (state) => state.userData.user
        }),
        matrix() {
            if (!this.purchases) {
                return this.listToMatrix([], 1)
            }
            if (!this.favorites) {
                return this.listToMatrix([], 1)
            }
            const skins = this.paySkins.filter(
                (item) => item.name.includes(this.search) || item.price.toString().includes(this.search)
            )
            // Verify purchase
            const storeSkins = []
            skins.forEach(elementFromList => {
                const skinFromList = elementFromList
                skinFromList.purchased = this.purchases.some(elementFromPurchased => {
                    return elementFromPurchased.productType === 'SKIN' && elementFromPurchased.skin && elementFromPurchased.skin.id === skinFromList.id
                })
                storeSkins.push(skinFromList)
            });
            // Verify favorite
            const storeSkinsFavoriteFilter = []
            storeSkins.forEach(elementFromList => {
                const skinFromList = elementFromList
                skinFromList.favorite = this.favorites.some(elementFromPurchased => {
                    return elementFromPurchased.id === skinFromList.id
                })
                storeSkinsFavoriteFilter.push(skinFromList)
            });
            // Verify favorite view
            let finalArray = storeSkinsFavoriteFilter
            if (this.favoriteView) {
                finalArray = storeSkinsFavoriteFilter.filter( (item) => item.favorite === true)
            }

            if (this.$vuetify.breakpoint.xs) {
                return this.listToMatrix(finalArray, 1)
            }
            if (this.$vuetify.breakpoint.sm) {
                return this.listToMatrix(finalArray, 2)
            }
            if (this.$vuetify.breakpoint.md) {
                return this.listToMatrix(finalArray, 3)
            }
            if (this.$vuetify.breakpoint.lg) {
                return this.listToMatrix(finalArray, 4)
            }
            return this.listToMatrix(finalArray, 5)
        }
    },
    mounted() {
        this.loadData()
    },
    methods: {
        getActiveSkins() {
            UserSkinService.getPagePaySkin(this.currentPage, 15)
                .then((response) => {
                    this.paySkins = response.content.content
                    this.totalPages = response.content.totalPages
                })
                .catch((error) => console.error(error))
        },
        getFavorites() {
            this.$emit('loaded', false)
            this.favorites = null
            SkinFavoriteService.getAllByUser(
                this.user.id
            )
            .then((response) => {
                this.$emit('loaded', true)
                this.favorites = response.content
            })
            .catch((error) => console.error(error))
        },
        getPurchases() {
            PurchaseService.getPurchasesByUser(
                this.user.id
            )
            .then((response) => {
                if (response.content.user) {
                    this.purchases = response.content.productList
                }
            })
            .catch((error) => console.error(error))
        },
        listToMatrix(list, elementsPerSubArray) {
            const matrix = []
            let i
            let k

            for (i = 0, k = -1; i < list.length; i+=1) {
                if (i % elementsPerSubArray === 0) {
                    k+=1;
                    matrix[k] = [];
                }
                matrix[k].push(list[i])
            }
            return matrix
        },
        async loadData() {
            await this.getFavorites()
            await this.getPurchases()
            await this.getActiveSkins()
        },
        verifyFavorite(data) {
            const currentFavorites = JSON.parse(JSON.stringify(this.favorites))
            this.favorites = null
            setTimeout(() => {
                this.filterFavorite(data, currentFavorites)
            }, 500)
        },
        filterFavorite(data, currentFavorites) {
            const favorites = currentFavorites
            if (data.favorite) {
                favorites.push( { id: data.id } )
                this.favorites = favorites
            } else {
                this.favorites = favorites.filter( (item) => item.id !== data.id )
            }
        },
        next() {
            if (this.currentPage < (this.totalPages - 1)) {
                this.currentPage += 1
                this.paySkins = []
                this.getActiveSkins()
            }
        },
        previous() {
            if (this.currentPage > 0) {
                this.currentPage -= 1
                this.paySkins = []
                this.getActiveSkins()
            }
        },
        toBuy (skin) {
            this.$emit('purchase', skin)
        }
    },
    watch: {
        reload() {
            this.getPurchases()
            this.getFavorites()
        }
    }
}
</script>
<style scoped>
.customCols {
  width: 100%;
  max-width: 100%;
  flex-basis: 100%;
}
@media (min-width: 600px) {
    .customCols {
        width: 50%;
        max-width: 50%;
        flex-basis: 50%;
    }
}
@media (min-width: 960px) {
    .customCols {
        width: 33%;
        max-width: 33%;
        flex-basis: 33%;
    }
}
@media (min-width: 1264px) {
    .customCols {
        width: 25%;
        max-width: 25%;
        flex-basis: 25%;
    }
}
@media (min-width: 1904px) {
    .customCols {
        width: 20%;
        max-width: 20%;
        flex-basis: 20%;
    }
}

.button-next-2-text-1 {
    color: white;
    font-size: 1vw;
    margin-bottom: 0;
    font-family: 'Open Sans';
}
.button-next-2-text-2 {
    color: #ff6f3a;
    font-size: 1vw;
    margin-bottom: 0;
    font-family: 'Open Sans';
}
.page-number {
    font-size: 1vw;
}
.page-total-number {
    color: #D7C5B0;
    font-size: 1vw;
}

@media (max-width: 1263px) {
    .button-next-2-text-1 {
        font-size: 3vw;
    }
    .button-next-2-text-2 {
        font-size: 3vw;
    }
    .page-number {
        font-size: 3vw;
    }
    .page-total-number {
        font-size: 3vw;
    }
}
</style>